export default __webpack_public_path__ + "static/media/directions_bike_24px.53835df2.svg";